/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.partner.demo.rpc.PartnerDemoDdgRpc
 */
import * as References from './PartnerDemoDdgRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noPortalHttp from 'hub-http/clients/noPortalApiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noPortalHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.partner.demo.rpc.PartnerDemoDdgRpc#generateDemoContent
 */
export const GENERATE_DEMO_CONTENT_MUTATION_FIELD_NAME = 'com_hubspot_partner_demo_rpc_PartnerDemoDdgRpc_generateDemoContent';
export const GENERATE_DEMO_CONTENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GENERATE_DEMO_CONTENT_MUTATION_FIELD_NAME,
  args: ['demoPortalId', 'featureTypes', 'parcelsUpdate', 'industry', 'dealId', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.generateDemoContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});